/**
 * @generated SignedSource<<f69c09a2b6082dd419adea026f66c616>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "ComparisonGeneratePdfResult",
    "kind": "LinkedField",
    "name": "finishedComparisonsSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sequence",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "frameId",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "comparisonId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "comparisonsDone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "passedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ComparisonDetails",
        "kind": "LinkedField",
        "name": "comparisonDetails",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "diffPngsIds",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referentPdfId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPdfId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinishedComparisonsSubscription",
    "selections": (v2/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinishedComparisonsSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "669f5c7598a40581c0a6018da2dd46a6",
    "id": null,
    "metadata": {},
    "name": "FinishedComparisonsSubscription",
    "operationKind": "subscription",
    "text": "subscription FinishedComparisonsSubscription(\n  $filter: BaseSubscriptionInput!\n) {\n  finishedComparisonsSubscription(filter: $filter) {\n    sequence\n    frameId\n    status\n    comparisonId\n    comparisonsDone\n    errorCount\n    failedCount\n    passedCount\n    comparisonDetails {\n      id\n      diffPngsIds\n      status\n      referentPdfId\n      actualPdfId\n      fileName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1335af4f56fa9628117604f091cf755c";

export default node;
